function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEstimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 180,
    height: 180,
    rx: 36,
    fill: "#8C7BAE",
    style: {
      fill: "rgb(140, 123, 174)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 52,
    width: 70,
    height: 85,
    rx: 8,
    fill: "none",
    stroke: "white",
    strokeWidth: 2.5,
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 62,
    width: 52,
    height: 18,
    rx: 3,
    fill: "white",
    opacity: 0.9,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.9,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 88,
    width: 13,
    height: 10,
    rx: 2,
    fill: "white",
    opacity: 0.8,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.8,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 88,
    width: 13,
    height: 10,
    rx: 2,
    fill: "white",
    opacity: 0.8,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.8,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 88,
    width: 13,
    height: 10,
    rx: 2,
    fill: "white",
    opacity: 0.8,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.8,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 103,
    width: 13,
    height: 10,
    rx: 2,
    fill: "white",
    opacity: 0.8,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.8,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 103,
    width: 13,
    height: 10,
    rx: 2,
    fill: "white",
    opacity: 0.8,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.8,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 103,
    width: 13,
    height: 10,
    rx: 2,
    fill: "white",
    opacity: 0.8,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.8,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 118,
    width: 32,
    height: 10,
    rx: 2,
    fill: "white",
    opacity: 0.8,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.8,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 118,
    width: 13,
    height: 10,
    rx: 2,
    fill: "white",
    opacity: 0.8,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.8,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 162,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "white",
    letterSpacing: 1,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Arial, sans-serif",
      fontSize: 13,
      fontWeight: 700,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "ESTIMATION"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEstimation);
export default __webpack_public_path__ + "static/media/Logo_estimation.f044aca68cda3d04c7f4a04dc16fc52f.svg";
export { ForwardRef as ReactComponent };